import http from "./env";
import AuthHeader from "./env";
import * as serviceToken from"./serviceToken";

export const GetAll = () => {
    return http.get("/Configuration/Get");
  };
